import { Input, SelectInput } from "@repo/ui";
import { configurationApi } from "~/api";
import { BrandImageUpload } from "./brand-image-upload";
import { useBrandCreationContext } from "../../contexts/brand-creation-context-provider";

export const BrandCreationHeader = () => {
  const { data: customers } = configurationApi.useQuery("get", "/api/Customer");
  const { updateState, state } = useBrandCreationContext();
  const { brandName, selectedCustomerId } = state;

  return (
    <div className="flex items-center gap-4 border-b border-gray-200 p-5">
      <BrandImageUpload />
      <Input
        required
        placeholder="Brand name"
        value={brandName}
        onChange={(e) => updateState("brandName", e.target.value)}
      />
      {!!customers?.length && (
        <SelectInput
          options={customers.map((customer) => ({
            label: customer.name,
            value: String(customer.id),
          }))}
          placeholder="Select Customer"
          value={selectedCustomerId}
          onChange={(val) => {
            updateState("selectedCustomerId", val as string);
          }}
          required
        />
      )}
    </div>
  );
};
